<template>
  <div>
    <div class="row q-pb-sm">
      <div class="col-sm-12 col-md-3 col-lg-3 col-xs-12 q-pr-sm">
        <q-select
          map-options
          emit-value
          v-model="searchClienteBy"
          dense
          :options="[
            { value: 'nomeFantasia', label: 'Fantasia' },
            { value: 'nome', label: 'Nome' },
            { label: 'CPF/CNPJ', value: 'cnpjCpf' },
            { label: 'ID', value: 'codCliente' }
          ]"
        />
      </div>
      <div class="col-sm-12 col-md-9 col-lg-9 col-xs-12 q-pr-sm">
        <q-input
          dense
          v-model="textFilterClientes"
          label="Digite algo para pesquisar"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xs-12">
        <q-table
          :data="filteredClientes"
          :grid="true"
          :loading="loading"
        >
          <template v-slot:item="props">
            <div class="col-12">
              <q-list dense>
                <q-item>
                  <q-item-section>
                    <q-item-label>{{props.row.nomeFantasia || props.row.nome}}</q-item-label>
                    <q-item-label caption lines="1">Código: {{props.row.codCliente}}</q-item-label>
                    <q-item-label caption lines="1">Nome: {{props.row.nome}}</q-item-label>
                    <q-item-label caption lines="1">Data Cadastro: {{props.row.dataCadastro | date}}</q-item-label>
                    <q-item-label caption lines="1">CPF/CNPJ:: {{props.row.cnpjCpf | cpfCnpj}}</q-item-label>
                  </q-item-section>
                  <q-item-section side top>
                    <q-item-label>
                      <q-btn v-if="tipoBotao.toUpperCase() === 'ADD'" icon="add" color="green" round dense size="sm" @click="select(props.row)" />
                      <q-btn v-if="tipoBotao.toUpperCase() === 'REMOVE'" icon="delete" color="red" round dense size="sm" @click="select(props.row)" />
                      <q-btn v-if="tipoBotao.toUpperCase() === 'SELECT'" icon="arrow_right_alt" color="primary" round dense size="sm" @click="select(props.row)" />
                    </q-item-label>
                  </q-item-section>
                </q-item>
                <q-separator spaced inset />
              </q-list>
            </div>
          </template>
        </q-table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'grid-clientes',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      required: true,
      default: 'TABLE',
      validator: (value) => value.toUpperCase() === 'TABLE' || value.toUpperCase() === 'LIST'
    },
    tipoBotao: {
      type: String,
      default: 'ADD',
      required: true,
    },
    clientes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      perPage: 10,
      currentClientePage: 1,
      textFilterClientes: '',
      searchClienteBy: 'nomeFantasia',
      tableClientes: {
        fields: [
          { key: 'codCliente', label: 'ID' },
          { key: 'cnpjCpf', label: 'CPF/CNPJ' },
          { key: 'nomeFantasia', label: 'Fantasia' },
          { key: 'nome', label: 'Nome' },
          { key: 'options', label: '' }
        ]
      }
    }
  },
  methods: {
    select (cliente) {
      this.$emit('on-select', cliente)
    }
  },
  computed: {
    filteredClientes () {
      return this.clientes
        .filter(cliente => this.textFilterClientes ? cliente[this.searchClienteBy].toLowerCase().includes(this.textFilterClientes.toLowerCase()) : cliente)
    },

    paginated () {
      const start = (this.currentClientePage -1) * this.perPage
      const end = this.currentClientePage * this.perPage
      return this.filteredClientes.slice(start, end)
    }
  },
  components: {
  }
}
</script>